import React from 'react';

interface ModalActionButtonsProps {
  onCancel?: () => void;
  onConfirm?: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
  confirmColor?: 'primary' | 'success' | 'danger' | 'warning' | 'info';
  disabled?: boolean;
}

const ModalActionButtons: React.FC<ModalActionButtonsProps> = ({
  onCancel,
  onConfirm,
  cancelLabel = 'Cancelar',
  confirmLabel = 'Confirmar',
  confirmColor = 'primary',
  disabled = false,
}) => {

  const colorMap = {
    primary: 'bg-primary hover:bg-primary/90',
    success: 'bg-[#3CA745] hover:bg-opacity-90',
    danger: 'bg-[#DC3545] hover:bg-opacity-90',
    warning: 'bg-[#F9C107] hover:bg-opacity-90 text-[#212B36]',
    info: 'bg-[#3BA2B8] hover:bg-opacity-90',
  };

  return (
    <div className="flex justify-end gap-3 border-t border-stroke pt-4 dark:border-strokedark">

      {onCancel && (
        <button
          type="button"
          onClick={onCancel}
          className="
            inline-flex items-center justify-center
            rounded-sm border border-stroke
            bg-whiten px-4 py-2
            text-sm font-medium text-body
            transition hover:bg-gray
            dark:border-strokedark dark:bg-boxdark dark:text-bodydark
          "
        >
          {cancelLabel}
        </button>
      )}

      {onConfirm && (
        <button
          type="button"
          onClick={onConfirm}
          disabled={disabled}
          className={`
            inline-flex items-center justify-center
            rounded-sm px-4 py-2
            text-sm font-medium text-white
            transition
            disabled:cursor-not-allowed disabled:opacity-50
            ${colorMap[confirmColor]}
          `}
        >
          {confirmLabel}
        </button>
      )}

    </div>
  );
};

export default ModalActionButtons;